// The widget passes the URL to window.open on the customer's site, so a
// javascript: link would run there.
const ALLOWED_PROTOCOLS = new Set([
	"http:",
	"https:",
	"mailto:",
	"tel:",
	"sms:",
])

export const WIDGET_LINK_URL_HINT =
	"Use a full link like https://acme.com, or a mailto:, tel: or sms: link."

export function normalizeWidgetLinkUrl(url: string | null | undefined) {
	return (url ?? "").trim()
}

export function isAllowedWidgetLinkUrl(url: string | null | undefined) {
	const value = normalizeWidgetLinkUrl(url)
	if (!value) return true
	try {
		return ALLOWED_PROTOCOLS.has(new URL(value).protocol)
	} catch {
		return false
	}
}
